var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSi = function SvgSi(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21786_20696",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21786_20696)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#D94837"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 6.66667,
    height: 20,
    transform: "rotate(90 20 0)",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6.66602,
    width: 6.66667,
    height: 20,
    transform: "rotate(90 20 6.66602)",
    fill: "#1B42B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33805 3.75451C6.54605 3.12731 4.86605 3.49318 4.25005 3.75451C4.16003 5.02821 4.27149 5.97246 4.49179 6.66648C4.91805 8.0094 5.75184 8.41544 6.32205 8.45848C8.38285 8.05528 8.52472 5.1545 8.33805 3.75451Z",
    fill: "#173B9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11437 6.66086L7.15961 5.54697L6.82361 5.99497L6.31961 5.04297L5.81561 5.99497L5.36761 5.54697L4.49609 6.69083C4.92464 8.01457 5.75186 8.41602 6.31866 8.4588C7.28334 8.27006 7.82753 7.53404 8.11437 6.66086Z",
    fill: "#F6F8FA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/si.020948d2a66f008ebdefb7dfc1d02097.svg";